import React from 'react'
import moment from "moment";
import { WizClassifySelect, WizTableForm } from '@/containers/common';
import _ from 'lodash';

import { component_tool, framework_tool, utils_tool } from '@/tool'
let { WizModal, WizTooltip } = component_tool

let componentName = 'watermarkManager'

const columns = [
    {
        title: 'id',
        name: 'id',
        formItem: {
            type: 'hidden'
        }
    },
    // 搜索区
    {
        title: '适用终端',
        name: 'platform',
        searchItem: {
            type: 'select'
        },
        dict: [
            { code: '0', codeName: 'PC管理端' },
            { code: '1', codeName: 'PC学员端' },
            { code: '2', codeName: 'APP' },
            // {code: 2, codeName: '企业号'},
            // {code: 3, codeName: '小程序'},
            { code: '8', codeName: 'PDF' },
        ]
    },
    {
      title: '水印类型',
      name: 'searchType',
      searchItem: {
        type: 'select'
      },
      dict: [
        { code: 0, codeName: '网页' },
        { code: 1, codeName: 'PDF' }
      ]
    },
    {
        title: '状态',
        name: 'state',
        searchItem: {
            type: 'select'
        },
        dict: [
            { code: 0, codeName: '禁用' },
            { code: 1, codeName: '启用' }
        ]
    },
    // 搜索end
    {
        title: '适用终端',
        name: 'platform',
        tableItem: {
            type: 'select'
        },
        dict: [
            { code: '0', codeName: 'PC管理端' },
            { code: '1', codeName: 'PC学员端' },
            { code: '2', codeName: 'APP' },
            // {code: 2, codeName: '企业号'},
            // {code: 3, codeName: '小程序'},
            { code: '8', codeName: 'PDF' },
        ]
    },
    {
      title: '水印类型',
      name: 'type',
      tableItem: {
        type: 'select'
      },
      dict: [
        { code: 0, codeName: '网页' },
        { code: 1, codeName: 'PDF' }
      ]
    },
    {
        title: '状态',
        name: 'state',
        tableItem: {
            type: 'select'
        },
        dict: [
            { code: 0, codeName: '禁用' },
            { code: 1, codeName: '启用' }
        ]
    },
    {
        title: '用户属性',
        name: 'scopeInfo',
        dict: [
            { code: 0, codeName: "培训平台用户" },
            { code: 5, codeName: "服务商用户" },
            { code: 4, codeName: "经销商用户" },
            { code: 3, codeName: "OEM部门用户" }
            // { code: 5, codeName: 'FSE' }
        ],
        tableItem: {
            type: 'checkbox',
        }
    }
];


const templateConfig = (e) => {
    return {
        mainProps: {},
        content: {
            name: "WizTableList",
            params: {
                columns,
                btnAccessCheck: false,
                searchBarProps: {
                    buttonSort: ['add'],
                    buttons: [
                        {
                            key: 'add',
                            custom: true,
                            params: { icon: 'plus', children: '新增', type: 'primary' },
                            customOnClick: {
                                key: 'jumpPage',
                                params: {
                                    key: 'push',
                                    pathname: '/watermark/add'
                                }
                            }
                        }
                    ],
                    dataFormat: (params) => {
                        let value = Object.assign({}, params)
                        if (value?.releaseTime?.length > 1) {
                            value.startDate = moment(value.releaseTime[0]).format('YYYY-MM-DD')
                            value.endDate = moment(value.releaseTime[1]).format('YYYY-MM-DD')
                            delete value.releaseTime
                        }
                        console.log(`value`, value)
                        return value
                    },
                },
                modalFormProps: {},
                dataTableProps: {
                    rowKey: "id",
                    selectType: "checkbox",
                    isScroll: true,
                    bordered: false,
                    paging: false,
                    loading: false
                },
                rowOperateSort: ['update', 'enableOrDisable'],
                rowOperateView: [
                    {
                        key: "update",
                        custom: true,
                        params: { children: "编辑" },
                        customOnClick: {
                            key: "jumpPage",
                            params: {
                                key: "push",
                                pathname: "/watermark/update"
                            }
                        }
                    },
                    {
                        key: "enableOrDisable",
                        custom: true,
                        params: { children: "启用" },
                        textFormat: {
                            recordKey: 'state',
                            dirt: { '1': '禁用', '0': '启用', }
                        },
                        customOnClick: {
                            key: "action",
                            params: {
                                apiKey: "enable",
                                apiParams: {}
                            },
                            formatParams: (rows, record, filters, callback) => {
                                const content = `您确定要${record['state'] === 0 ? '开启' : '关闭'
                                    }水印配置吗？`;
                                WizModal.confirm({
                                    title: '注意', content,
                                    onOk: () => {
                                        callback && callback({
                                            state: record['state'] === 0 ? 1 : 0,
                                            id: record['id'],
                                        })
                                    },
                                    onCancel() {
                                    }
                                });
                                return null
                            }
                        }
                    },

                ]
            }
        }
    }
};

const apis = {
    list: {
        path: `${componentName}/list`,
        payload: {
            key: `${componentName}@list`,
            apiParams: {}
        }
    },
    enable: {
        path: `${componentName}/enable`,
        payload: {
            key: `${componentName}@enable`,
            apiParams: {}
        }
    },
    // delete: {
    //     path: `${componentName}/delete`,
    //     payload: {
    //         key: `${componentName}@delete`,
    //         apiParams: {}
    //     }
    // },
}

let reduxTemplateConfig = (args) => {
    return {
        apis,
        componentName,
        initApiKeys: ['list'],
        keepInitApiParams: true,
        needLoading: true,
        ...args
    }
};

export { reduxTemplateConfig, templateConfig, columns };
